import {
    call,
    put,
    select,
    takeLatest,
} from 'redux-saga/effects'

import checkPermission from '../../@paco/helpers/permissions/checkPermission'

import { getDocumentTypes } from '../../helpers/api-ts/documentType'
import { getLoketInfo } from '../../helpers/api-ts/loket'
import {
    PZ_GET_DOCUMENT_TYPES_FAILURE,
    PZ_GET_DOCUMENT_TYPES_REQUEST,
    PZ_GET_DOCUMENT_TYPES_SUCCESS,
    PZ_GET_LOKET_INFO_FAILURE,
    PZ_GET_LOKET_INFO_REQUEST,
    PZ_GET_LOKET_INFO_SUCCESS,
    PZ_SAGA_GET_DOCUMENT_TYPES,
    PZ_SAGA_GET_LOKET_INFO,
} from '../actionTypes'

function* fetchDocumentTypes(): any {
    yield put({ type: PZ_GET_DOCUMENT_TYPES_REQUEST })

    try {
        const documentTypes = yield call(() => getDocumentTypes())
        const state = yield select()
        const { permissions } = state.authenticatedUserReducer

        if (checkPermission(permissions, 'view-all-document-types')) {
            yield put({ type: PZ_GET_DOCUMENT_TYPES_SUCCESS, documentTypes })
        }
    } catch (error) {
        yield put({ type: PZ_GET_DOCUMENT_TYPES_FAILURE, errors: [error] })
    }
}

function* getLoketData(): any {
    yield put({ type: PZ_GET_LOKET_INFO_REQUEST })

    try {
        const response = yield call(() => getLoketInfo())

        yield put({ type: PZ_GET_LOKET_INFO_SUCCESS, loketData: response.data })
    } catch (error) {
        yield put({ type: PZ_GET_LOKET_INFO_FAILURE, errors: [error] })
    }
}


export default function* pzWatcher() {
    yield takeLatest(PZ_SAGA_GET_DOCUMENT_TYPES, fetchDocumentTypes)
    yield takeLatest(PZ_SAGA_GET_LOKET_INFO, getLoketData)
}
